var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-product-overview__link--orderable-label"},[_vm._v("\n  "+_vm._s(_vm.getProductOverviewTranslations['ProductsOverview.Orderable'])+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }